export default "__VITE_ASSET__BBSg6Hyw__"